export interface PhoneCode {
  flag: string;
  value: string;
}

export const phoneCodes: PhoneCode[] = [
  // DACH – priority
  { flag: "🇩🇪", value: "+49" },
  { flag: "🇦🇹", value: "+43" },
  { flag: "🇨🇭", value: "+41" },

  // North America (common)
  { flag: "🇺🇸", value: "+1" },

  // Europe – ordered by dial code
  { flag: "🇬🇷", value: "+30" },
  { flag: "🇳🇱", value: "+31" },
  { flag: "🇧🇪", value: "+32" },
  { flag: "🇫🇷", value: "+33" },
  { flag: "🇪🇸", value: "+34" },
  { flag: "🇭🇺", value: "+36" },
  { flag: "🇮🇹", value: "+39" },
  { flag: "🇷🇴", value: "+40" },
  { flag: "🇬🇧", value: "+44" },
  { flag: "🇩🇰", value: "+45" },
  { flag: "🇸🇪", value: "+46" },
  { flag: "🇳🇴", value: "+47" },
  { flag: "🇵🇱", value: "+48" },
  { flag: "🇵🇹", value: "+351" },
  { flag: "🇱🇺", value: "+352" },
  { flag: "🇮🇪", value: "+353" },
  { flag: "🇮🇸", value: "+354" },
  { flag: "🇦🇱", value: "+355" },
  { flag: "🇲🇹", value: "+356" },
  { flag: "🇨🇾", value: "+357" },
  { flag: "🇫🇮", value: "+358" },
  { flag: "🇧🇬", value: "+359" },
  { flag: "🇱🇹", value: "+370" },
  { flag: "🇱🇻", value: "+371" },
  { flag: "🇪🇪", value: "+372" },
  { flag: "🇲🇩", value: "+373" },
  { flag: "🇦🇲", value: "+374" },
  { flag: "🇧🇾", value: "+375" },
  { flag: "🇦🇩", value: "+376" },
  { flag: "🇲🇨", value: "+377" },
  { flag: "🇸🇲", value: "+378" },
  { flag: "🇺🇦", value: "+380" },
  { flag: "🇷🇸", value: "+381" },
  { flag: "🇲🇪", value: "+382" },
  { flag: "🇽🇰", value: "+383" },
  { flag: "🇭🇷", value: "+385" },
  { flag: "🇸🇮", value: "+386" },
  { flag: "🇧🇦", value: "+387" },
  { flag: "🇲🇰", value: "+389" },
  { flag: "🇨🇿", value: "+420" },
  { flag: "🇸🇰", value: "+421" },
];
